// extracted by mini-css-extract-plugin
module.exports = {"container":"j3qe6","radioButton":"_1XhIE","radioButtonIcon":"_3N-pz","subtitle":"_3HP97","frequency":"_2bFE3","duration":"_22W16"};